<template>
  <transition name="modal-fade">
    <div class="modal-backdrop-5">
      <div class="modal-5" role="dialog">
        <header class="modal-header">
          <h4>Purchase Request Details</h4>
          <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close modal"></button>
        </header>
        <section class="modal-body">
          <div v-if="request">
            <div class="section">
              <h5>General Information</h5>
              <div class="info-grid">
                <div class="info-card">
                  <div class="label">Request No</div>
                  <div class="value">{{ request.purchaseRequestNo }}</div>
                </div>
                <div class="info-card">
                  <div class="label">Date</div>
                  <div class="value">{{ formatDate(request.createdAt) }}</div>
                </div>
                <div class="info-card">
                  <div class="label">Status</div>
                  <div class="value">{{ request.status }}</div>
                </div>

                <div class="info-card">
                  <div class="label">Department</div>
                  <div class="value">{{ request.Department?.name || request.department || request.departmentName || '-' }}</div>
                </div>
                <div class="info-card">
                  <div class="label">Project</div>
                  <div class="value">{{ request.Project?.name || request.project || request.projectName || '-' }}</div>
                </div>

                <div class="info-card">
                  <div class="label">Urgency</div>
                  <div class="value">{{ request.urgency }}</div>
                </div>
                <div class="info-card">
                  <div class="label">Requested By</div>
                  <div class="value">{{ request.requestedBy?.name }}</div>
                </div>

                <div class="info-card info-wide">
                  <div class="label">Justification</div>
                  <div class="value">{{ request.justification }}</div>
                </div>
                <div class="info-card info-wide">
                  <div class="label">Description</div>
                  <div class="value">{{ request.description }}</div>
                </div>
              </div>
            </div>
            <div class="section">
              <h5>Items</h5>
              <table class="table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Product</th>
                    <th>Code</th>
                    <th>Unit</th>
                    <th>Qty</th>
                    <th>Est. Unit Price</th>
                    <th>Est. Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in request.items" :key="item.id">
                    <td>{{ idx + 1 }}</td>
                    <td>{{ item.product?.name }}</td>
                    <td>{{ item.product?.code }}</td>
                    <td>{{ item.product?.unit?.name }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ formatMoney(item.estimatedUnitPrice) }}</td>
                    <td>{{ formatMoney(item.estimatedTotalPrice) }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="total-row">
                <strong>Total Amount:</strong> {{ formatMoney(request.totalAmount) }}
              </div>
            </div>
            <div v-if="request.approvals && request.approvals.length" class="section">
              <h5>Approval Timeline</h5>
              <div v-for="approval in request.approvals" :key="approval.id" class="approval-item" :class="approval.status">
                <div class="approval-header">
                  <span>{{ approval.status }} by {{ approval.approver?.name }} on {{ formatDate(approval.updatedAt) }}</span>
                  <span class="approval-decision" :class="approval.status">{{ approval.status }}</span>
                </div>
                <div v-if="approval.comment" class="approval-comments">Comment: {{ approval.comment }}</div>
              </div>
            </div>
          </div>
          <div v-else class="text-center text-danger">No details found.</div>
        </section>
        <footer class="modal-footer">
          <button class="btn btn-secondary" @click="$emit('close')">Close</button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PurchaseRequestDetailsModal',
  props: {
    request: { type: Object, required: true }
  },
  methods: {
    formatDate(date, withTime = false) {
      if (!date) return '';
      const d = new Date(date);
      return withTime
        ? d.toLocaleString()
        : d.toLocaleDateString();
    },
    formatMoney(val) {
      if (val == null) return '';
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES', currencyDisplay: 'narrowSymbol' }).format(val);
    }
  }
}
</script>

<style scoped>
.modal-backdrop-5 {
  position: fixed;
  top:0; right:0; bottom:0; left:0 ;
  background-color: rgba(0, 0, 0, 0.7) !important;
  z-index: 1000;
  display: flex !important;
  justify-content: center !important;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 3% !important;
}
.modal-5 {
  background: #FFFFFF;
  box-shadow: 2px 2px 20px 1px rgba(0, 0, 0, 0.5);
  display: flex !important;
  flex-direction: column;
  width: 90% !important;
  max-width: 900px;
  max-height: 90vh;
  overflow: hidden;
  padding: 0 !important;
  z-index: 1001;
}

.modal-5 > .modal-header,
.modal-5 > .modal-body,
.modal-5 > .modal-footer {
  padding: 20px;
}

.modal-body {
  overflow-y: auto;
}


  .modal-header {
    padding: 15px;
    display: flex;
    gap: 10px;
  }

  .modal-headerr {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #000;
    justify-content: space-between;
    padding: 10px 10px 10px 20px;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 14px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #000000;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #000000;
    border: 1px solid #000000;
    border-radius: 2px;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }

.section {
  margin-bottom: 24px;
}
.info-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 4px;
  margin-bottom: 12px;
  border-radius: 8px;
  background: #fff;
}
.info-table th, .info-table td {
  padding: 8px 12px;
  vertical-align: top;
}
.info-table th {
  background: #f8f9fa;
  font-weight: bold;
}
.info-table tr:not(:last-child) td {
  border-bottom: 1px solid #f0f0f0;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
.info-card {
  background: #fff;
  border: 1px solid #eef0f2;
  padding: 10px 12px;
  border-radius: 6px;
}
.info-card .label {
  font-size: 12px;
  color: #7a7a7a;
  margin-bottom: 6px;
}
.info-card .value {
  font-size: 14px;
  color: #222;
  font-weight: 600;
}
.info-card.info-wide {
  grid-column: 1 / -1;
}
.table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 12px;
}
.table th, .table td {
  border: 1px solid #eee;
  padding: 8px 10px;
  text-align: left;
}
.table th {
  background: #f8f9fa;
}
.total-row {
  text-align: right;
  font-weight: bold;
  margin-top: 8px;
}
.approval-item {
  background: #f8f9fa;
  border-left: 4px solid #ddd;
  margin-bottom: 10px;
  padding: 10px 14px;
  border-radius: 6px;
}
.approval-item.APPROVED {
  border-left-color: #28a745;
  background: #f1f9f3;
}
.approval-item.REJECTED {
  border-left-color: #dc3545;
  background: #fdf2f2;
}
.approval-header {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.approval-decision {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  font-weight: bold;
  margin-left: auto;
}
.approval-decision.APPROVED {
  background: #28a745;
  color: white;
}
.approval-decision.REJECTED {
  background: #dc3545;
  color: white;
}
.approval-comments {
  background: white;
  padding: 10px;
  border-radius: 4px;
  margin-top: 8px;
  font-size: 14px;
  border: 1px solid #e9ecef;
}
.btn-close {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}
</style>
